import React from 'react';

import { ImageStyled } from './ImageTextCard.styled';

export interface ImageTextCardProps {
  imageLink?: string;
  text: string;
}

export const ImageTextCard: React.FC<ImageTextCardProps> = ({
  imageLink,
  text,
}: ImageTextCardProps) => {
  return (
    <div>
      {imageLink && <ImageStyled src={imageLink} />}
      <p>{text}</p>
    </div>
  );
};
